import React from 'react';
import { useNavigate } from 'react-router-dom';

import {
  Actions,
  BookingButton,
  Container,
  Greeting,
  GreetingLine,
  ProfileInfo
} from './Header.styled';
import { ProfileImageUploadButton } from 'components/PhotoUpload/ProfilePhoto/ProfileImageUploadButton';
import { Button } from 'components/v2/Buttons/Button/Button';
import { Heading } from 'components/v2/Typography/Heading';
import { analytics } from 'utilities/analytics';
import { pageUrl } from 'utilities/pageUrl';
import { useBreakpoints } from 'utilities/useBreakpoints';

import { Props } from './Header.types';
import { DashboardSettings } from '../DashboardSettings/DashboardSettings';

export const Header = ({ name, hasMembershipDocument, documentUrl }: Props) => {
  const { isMobile, isDesktop } = useBreakpoints();
  const navigate = useNavigate();

  const greetingLines = [];
  if (isMobile) {
    greetingLines.push('Hello,');
    greetingLines.push(name);
  } else {
    greetingLines.push(`Hello, ${name}`);
  }

  return (
    <Container>
      <ProfileInfo>
        <ProfileImageUploadButton id="dashboard-profile-image-upload" size={isDesktop ? 64 : 40} />
        <Greeting>
          {greetingLines.map((line, index) => {
            return (
              <GreetingLine key={index}>
                <Heading tag="h1" noMargin>
                  {line}
                </Heading>
              </GreetingLine>
            );
          })}
        </Greeting>
      </ProfileInfo>

      <Actions>
        <DashboardSettings buttonLabel="Customize Dashboard" hideSettings={false} size="md" />
        {hasMembershipDocument && (
          <Button
            category="secondary"
            label="View Member Guide"
            onClick={() => window.open(documentUrl, '_blank', 'noreferrer noopener')}
            size={isMobile ? 'sm' : 'md'}
          />
        )}
        <BookingButton
          category="primary"
          label="Schedule Appointment"
          onClick={() => {
            analytics.track(analytics.EVENTS.APPOINTMENT_BOOKING_STARTED);
            navigate(pageUrl.booking.bookingQuiz());
          }}
          size={isMobile ? 'sm' : 'md'}
        />
      </Actions>
    </Container>
  );
};
